module.exports = __webpack_public_path__ + "static/img/ent-5.46f5178.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-5.jpg
// module id = Ilm3
// module chunks = 52